<div class="sg_container" *ngIf="key">
  <div class="text_bold">
    {{key.key_name}}
  </div>
</div>